<template>
  <div class="experience" v-if="model">
    <div class="roles">
      <role v-for="(role, i) in model.roles" :key="i"
            :model="role"></role>
    </div>
    <div class="notes">
      <div v-for="(note, i) in model.notes()" :key="i"
           class="note">{{ note }}</div>
    </div>
    <ul class="highlights" ref="highlightsNode">
      <li v-for="(fragment, i) in higlightMarkup"
          :key="i"
          class="highlight"
          v-html="fragment"></li>
    </ul>
    <div class="details" ref="detailsNode">
      <p v-for="(fragment, i) in detailMarkup"
         :key="i"
         class="md"
         v-html="fragment"></p>
    </div>
  </div>
</template>

<script>

import Role from './role';

import MarkdownMixin from '@/mixins/markdown';

export default {
    name       : "Experience",
    components : { Role },
    mixins     : [ MarkdownMixin ],
    props      : {
        model : {
            type : Object
        }
    },
    computed : {
        detailMarkup() {
            return this.model.details().map(text => {
                return this.markdown.renderInline(text.trim());
            });
        },
        higlightMarkup() {
            return this.model.highlights().map(text => {
                return this.markdown.renderInline(text.trim());
            });
        }
    }
};

</script>

<style scoped>

.experience {
    break-inside:avoid;
    padding-bottom:80px;
}

.experience .notes {
}

.experience .roles {
    border-bottom:1px solid #FF8000;
}

.experience .highlights {
    margin:0px;
    padding:0px 0px 0px 20px;
}

.experience .notes > .note {
    font-size:14px;
    font-style:italic;
    text-align:right;
}

.experience .highlights,
.experience .details {
    text-align:left;
    margin-top:15px;
}

.experience .details > p,
.experience .highlights > .highlight {
    font-size:12px;
}


@media print {
    .experience .roles {
        border-bottom:1px solid #CCCCCC;
    }
}

</style>
